import { buildFilterKey, MAKER_MINUMUM_FILTER_TYPE } from "@faire/retailer-shared/filters/filterKeys";
import { getAllBrandsLink } from "@faire/retailer-visitor-shared/consts/allBrandsLinks";
import { getSettingLowOrderMinimumThreshold } from "@faire/retailer-visitor-shared/settings/getSettingLowOrderMinimumThreshold";
export var getNoMinimumFilterLink = function() {
    return getAllBrandsLink({
        filters: [
            getNoMinimumFilter()
        ]
    });
};
var getNoMinimumFilter = function() {
    return buildFilterKey(MAKER_MINUMUM_FILTER_TYPE, "no_minimum_".concat(getLoggedOutCurrency()));
};
var getLoggedOutCurrency = function() {
    var _getSettingLowOrderMinimumThreshold_currency;
    return getSettingLowOrderMinimumThreshold().currency === "USD" ? "dollars" : (_getSettingLowOrderMinimumThreshold_currency = getSettingLowOrderMinimumThreshold().currency) === null || _getSettingLowOrderMinimumThreshold_currency === void 0 ? void 0 : _getSettingLowOrderMinimumThreshold_currency.toLowerCase();
};
